import type {PortaroState} from 'src/typings';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {AjaxService} from 'core/data-services/ajax.service';

export class ServerStateDataService {
    public static serviceName = 'serverStateDataService';

    public static readonly ROUTE = 'info';

    /*@ngInject*/
    constructor(private ajaxService: AjaxService) {
    }

    @ngAsync()
    public async getServerState(): Promise<PortaroState> {
        return this.ajaxService
            .createRequest(ServerStateDataService.ROUTE)
            .get();
    }
}